import { IconBox, LightningBoltIcon } from "@hightouch/htui";
import type { SchemaIconProps } from "./types";

export const LightningIcon = ({ size = "xl", ...props }: SchemaIconProps) => {
  return (
    <IconBox color="teal" icon={<LightningBoltIcon />} size={size} {...props} />
  );
};
